/**
 * The LayerHostProvider is used to provide context to the layerhosts about the context of the requests that are being broadcast over th eapplication
 *
 * @module views/components/LayerHostProvider
 * @memberof -Common
 */
import React, { useContext, createContext, useState } from 'react';

/**
 * Context context object for react reuse
 * @type object
 */
export const LayerHostContext = createContext();


export const broadcastModuleUpdate = function( setRefreshAction, setRefreshContentId, setRefreshData ){
  return ( methods, data ) => {
    const {
      action,
      contentId,
      data: refreshData
    } = data;
    const updatedAction = { ...action, variables: { ...action?.variables, contentId } }
    setRefreshContentId( contentId );

    if( refreshData ){
      setRefreshData( refreshData )
    }
    else if( action ){
      // TODO the action should be modified with the contentID for the request and then tha should be sent
      setRefreshAction( updatedAction );
    }

  }
}

export const clearBroadcastModuleUpdate = function( setRefreshAction, setRefreshContentId, setRefreshData ){
  return () => {
    setRefreshContentId( null );
    setRefreshAction( null );
    setRefreshData( null );
  }
}

/**
 * Represents a LayerHostProvider component
 *
 * @method
 * @param {object} props - React properties passed from composition
 * @returns LayerHostProvider
 */
export const LayerHostProvider = function( props ){
  const [refreshContentId, setRefreshContentId] = useState( null )
  const [refreshAction, setRefreshAction] = useState( null )
  const [refreshData, setRefreshData] = useState( null )

  return (
    <LayerHostContext.Provider
      value={ {
        broadcastModuleUpdate: broadcastModuleUpdate( setRefreshAction, setRefreshContentId, setRefreshData ),
        clearBroadcastModuleUpdate: clearBroadcastModuleUpdate( setRefreshAction, setRefreshContentId, setRefreshData ),
        refreshContentId,
        refreshAction,
        refreshData
      } }
    >
      { props.children }
    </LayerHostContext.Provider>
  )
}


export default LayerHostProvider;

/**
 * context provider
 * @type object
 */
export const useLayerHostContext = () => useContext( LayerHostContext );
